module.exports = __webpack_public_path__ + "static/img/a2.87924bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a2.png
// module id = dv0K
// module chunks = 0